import {QuestionsAPI} from 'api/questions';
import {TrackingAPI} from 'api/tracking';
import {Button} from 'components/system/button';
import {Latex} from 'components/system/latex';
import {Spinner} from 'components/system/spinner';
import {TextContainer} from 'components/system/text_container';
import {useOutsideClick} from 'hooks/outside_click';
import {CloseIcon} from 'icons';
import {useEffect, useRef, useState} from 'react';
import {classNames} from 'utils';
import styles from './question_preview.module.css';

export const QuestionPreview = ({question, onChange}: Props) => {
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [questionPreview, setQuestionPreview] = useState<QuestionPreview | null>(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    TrackingAPI.questionPreview(question.uuid);
    setAnimate(true);
  }, [question]);

  const node = useRef<HTMLDivElement>(null);
  useOutsideClick(node.current!, () => {
    // This hurts my programmer soul.
    onChange('aaa');
  });

  useEffect(() => {
    if (!questionPreview) {
      const getQuestionDetails = async () => {
        setLoadingPreview(true);
        const questionPreviewData = await QuestionsAPI.getQuestionPreview(question.slug);
        if ((questionPreviewData as any).error) {
          return;
        }

        setLoadingPreview(false);
        setQuestionPreview(questionPreviewData);
      };
      getQuestionDetails();
    }
  }, [question]);

  return (
    <div
      ref={node}
      data-question-preview={question.slug}
      className={classNames([styles.questionContainerPreview, animate && styles.hoverLink])}>
      {loadingPreview && <Spinner text='loading question preview' size='sm'></Spinner>}
      {questionPreview && (
        <div className={styles.modalContainer}>
          <div className={styles.upper}>
            <div className={styles.modalHeader}>
              <h2>{questionPreview.title}</h2>
              <Button title='Close preview' type='icon' onClick={() => onChange('')}>
                <CloseIcon />
              </Button>
            </div>
            <div className={styles.questionBodyPreview}>
              <TextContainer>
                <Latex>{questionPreview.body}</Latex>
              </TextContainer>
            </div>
          </div>
          <div className={styles.navigate}>
            <p>Access the full question details, submit your answer, and more.</p>
            <div className={styles.buttons}>
              <Button color='blue' size='md' href={`/questions/${question.slug}`}>
                Answer question
              </Button>
              {question.has_solution && (
                <Button color='orange' size='md' href={`/questions/${question.slug}?solution=true`}>
                  Show solution
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

type Props = {
  question: Question;
  onChange: (question_slug: string) => void;
};

export default QuestionPreview;
